import App from '../../containers/App'

import {
  demoData,
  Container,
  Content, 
  GlobalStyles, 
  StyleSheets,
  Header, 
  HeaderRow, 
  DemoContent,
  DemoLogo,
} from '../demo-utils'

const AppDemo = () => (<> 
    <StyleSheets url={demoData.config.stylesheetURL} />
    <GlobalStyles fontFamily={demoData.config.fontFamily} />
    <HeaderRow {...demoData.theme.header}>
        <Container style={{color: 'white'}}>
          <App />
        </Container>
    </HeaderRow>
</>)

export default AppDemo
